import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportToExcel({ filename, sheetName, data, metadata = [] }) {
  // Create sheet from table data
  const ws1 = XLSX.utils.json_to_sheet(data);

  // Optional metadata sheet
  const ws2 = XLSX.utils.aoa_to_sheet(metadata);

  // Create workbook and append both sheets
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws1, sheetName || "Daten");
  if (metadata.length > 0) {
    XLSX.utils.book_append_sheet(wb, ws2, "Metadaten");
  }

  // Write file
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([wbout], { type: "application/octet-stream" }),
    `${filename || "export"}.xlsx`
  );
}
